import { isBrowser } from '@croquiscom/web2app';
import { CouponPayload } from '../types';
import { GetOrderSheet } from 'api2/types';

type OrderShopList = NonNullable<GetOrderSheet['order_sheet']>['order_shop_list'][number];

const KEY_MAP = {
  cart_shop_list: '/cart/cart_shop_list',
  order_shop_list: '/order_sheet/order_shop_list',
  user_account_coupon_list: '/user_account_coupon_list',
  coupon_payloads: '/coupon_payloads',
  selected_group_type: '/selected_group_type',
};

type KEY = keyof typeof KEY_MAP;

export default class LocalDataStorage {
  static saveDataInLocalStorage<T>(data_to_save: T, key: KEY) {
    if (isBrowser() && typeof localStorage !== 'undefined') {
      localStorage.setItem(KEY_MAP[key], JSON.stringify(data_to_save));
    }
  }

  static getDataInLocalStorage(key: KEY) {
    if (isBrowser() && typeof localStorage !== 'undefined') {
      return JSON.parse(localStorage.getItem(KEY_MAP[key])!);
    } else {
      return null;
    }
  }

  static clearCouponRelatedLocalInfo() {
    Object.keys(KEY_MAP).forEach((key) => {
      // @ts-ignore
      localStorage.removeItem(KEY_MAP[key]);
    });
  }

  static saveOrderShopList(order_shop_list: OrderShopList[]): void {
    LocalDataStorage.saveDataInLocalStorage(order_shop_list, 'order_shop_list');
  }
  static getOrderShopList(): OrderShopList[] {
    return LocalDataStorage.getDataInLocalStorage('order_shop_list');
  }

  static saveCouponPayloads(couponPayloads: CouponPayload[]) {
    LocalDataStorage.saveDataInLocalStorage(couponPayloads, 'coupon_payloads');
  }
  static getCouponPayloads(): CouponPayload[] {
    return LocalDataStorage.getDataInLocalStorage('coupon_payloads') || [];
  }
}
